import React, { useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import "../../css/Commission.css";
import Spinner from "../loading/spinner";
import SidebarContext from "../sidebarcontext/SidebarContext";
import CasContext from "../contextfolder/CasContext/CasContext";
import AcademicHeader from "../AcademicHeader";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function CasInput() {
  const { todayDate, customStyles, AcademicYear } = useContext(SidebarContext);
  const {
    loading,
    setLoading,
    academicYearList,
    selectAcademicYear,
    setSelectAcademicYear,
    classList,
    sectionList,
    subjectList,
    termList,
    themeList,
    achieveList,
    rankList,
    casList,
    setCasList,
    selectClass,
    setSelectClass,
    selectSection,
    setSelectSection,
    selectSubject,
    setSelectSubject,
    selectTerm,
    setSelectTerm,
    selectTheme,
    setSelectTheme,
    selectAchieve,
    setSelectAchieve,
    selectDate,
    setSelectDate,
    getCasList,
    saveCas,
  } = useContext(CasContext);

  const userinfo = JSON.parse(localStorage.getItem("userInfo"));

  const [casData, setCasData] = useState([]);

  useEffect(() => {
    setCasData(casList);
  }, [casList]);

  const handleAcademicYear = (e) => {
    setSelectAcademicYear(e.target.value);
    setSelectClass("");
    setSelectSection("");
    setSelectSubject("");
    setSelectTerm("");
    setSelectTheme("");
    setSelectAchieve("");
    setCasData([]);
  };

  const handleClass = (e) => {
    setSelectClass(e.target.value);
    setSelectSection("");
    setSelectSubject("");
    setSelectTerm("");
    setSelectTheme("");
    setSelectAchieve("");
    setCasData([]);
  };

  const handleSection = (e) => {
    setSelectSection(e.target.value);
    setSelectSubject("");
    setSelectTheme("");
    setSelectAchieve("");
    setCasData([]);
  };

  const handleSubject = (e) => {
    setSelectSubject(e.target.value);
    setSelectTheme("");
    setSelectAchieve("");
    setCasData([]);
  };

  const handleTerm = (e) => {
    setSelectTerm(e.target.value);
    setSelectTheme("");
    setSelectAchieve("");
    setCasData([]);
  };

  const handleTheme = (e) => {
    setSelectTheme(e.target.value);
    setSelectAchieve("");
    setCasData([]);
  };

  const handleAchieve = (e) => {
    setSelectAchieve(e.target.value);
  };

  const handleDate = ({ adDate }) => {
    setSelectDate(adDate);
  };

  const handleRankChange = (row, rankID) => {
    const updated = casData.map((item) => {
      if (item.StudentID === row.StudentID) {
        return { ...item, Rank: rankID };
      }
      return item;
    });
    setCasData(updated);
  };

  const handleSave = () => {
    const param = casData.map((item) => ({
      MemID: item.StudentID,
      RankID: item.Rank ? item.Rank.toString() : "",
    }));
    saveCas(param);
  };

  // Excel Export
  const dataToExcel = casData.map((d, i) => ({
    "S.N.": i + 1,
    "Roll No": d.RollNo,
    Student: d.FullName,
    Rank: d.Rank || "",
  }));

  const toExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(dataToExcel);
      var wscols = [{ wch: 5 }, { wch: 10 }, { wch: 30 }, { wch: 15 }];
      worksheet["!cols"] = wscols;
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "CAS_Input");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        module.default.saveAs(
          data,
          fileName + "_" + "export" + EXCEL_EXTENSION
        );
      }
    });
  };

  // PDF Export
  const dataWithIndex = casData.map((d, i) => ({
    ...d,
    Index: i + 1,
  }));

  const cols = [
    { header: "S.N", field: "Index" },
    { header: "Roll No", field: "RollNo" },
    { header: "Student", field: "FullName" },
    { header: "Rank", field: "Rank" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const toPdf = () => {
    const doc = new jsPDF("p", "pt", "a4", true);

    var midPage = doc.internal.pageSize.getWidth() / 2;

    doc.setFontSize(18);
    doc.text(`${userinfo.SchName}`, midPage, 50, null, null, "center");

    doc.setFontSize(15);
    doc.text(`${userinfo.SchAddress}`, midPage, 68, null, null, "center");

    doc.setFontSize(10);
    doc.text(
      `Tel:${userinfo.Phone}, E-mail:${userinfo.Email}`,
      midPage,
      85,
      null,
      null,
      "center"
    );

    doc.autoTable({
      startY: 100,
      theme: "grid",
      columns: exportColumns,
      body: dataWithIndex,
    });
    doc.save("CAS_Input.pdf");
  };

  const columns = [
    {
      name: "R.N.",
      width: "70px",
      center: true,
      selector: (row) => row.RollNo,
    },
    {
      name: "Student",
      selector: (row) => row.FullName,
    },
    {
      name: "Rank",
      width: "180px",
      center: true,
      cell: (row) => (
        <select
          style={{ fontSize: "11px" }}
          className="form-control form-control-sm"
          value={String(row.Rank || "")}
          onChange={(e) => handleRankChange(row, e.target.value)}
        >
          <option value="" disabled style={{ fontSize: "11px" }}>
            Select Rank
          </option>
          {rankList.map((rank) => (
            <option key={rank.RankID} value={rank.RankID}>
              {rank.Rank}
            </option>
          ))}
        </select>
      ),
    },
  ];

  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 contentMainSection">
        <div className="row">
          <div className="page-header">
            <div className="text-start  page-title">
              CAS Input
            </div>
            <div className="page-date">
              <div className="sec-content">
                <AcademicHeader
                  todayDate={todayDate}
                  AcademicYear={AcademicYear}
                />
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="main-content">
          {casData.length > 0 && (
            <div className="d-flex justify-content-end align-items-center mb-2">
              <button
                className="btn btn-sm btn-cmpy mx-2"
                onClick={handleSave}
              >
                Save
              </button>
              <div className="exportDiv">
                <Tippy content="Excel">
                  <button className="exportButtons mx-2" onClick={toExcel}>
                    <i className="bi bi-file-earmark-excel-fill exportButtonIconsExcel"></i>
                  </button>
                </Tippy>
                <Tippy content="PDF">
                  <button className="exportButtons" onClick={toPdf}>
                    <i className="bi bi-file-earmark-pdf-fill exportButtonIconsPdf"></i>
                  </button>
                </Tippy>
              </div>
            </div>
          )}

          <div className="sec-dataTable">
            {loading ? (
              <Spinner />
            ) : (
              <DataTable
                columns={columns}
                data={casData}
                customStyles={customStyles}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="280px"
                highlightOnHover
                pointerOnHover
                responsive
                dense
                striped
                subHeader
                subHeaderAlign="left"
                subHeaderComponent={
                  <>
                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown">
                      <label className="list-label">Academic Year</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectAcademicYear}
                        onChange={handleAcademicYear}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Year
                        </option>
                        {academicYearList.map((item) => (
                          <option
                            key={item.AcademicYear}
                            value={item.AcademicYear}
                          >
                            {item.AcademicYear}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Class</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectClass}
                        onChange={handleClass}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Class
                        </option>
                        {classList.map((item) => (
                          <option key={item.ClassID} value={item.ClassID}>
                            {item.ClassName}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Section</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectSection}
                        onChange={handleSection}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Section
                        </option>
                        {sectionList.map((item) => (
                          <option key={item.SectionID} value={item.SectionID}>
                            {item.SectionName}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Subject</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectSubject}
                        onChange={handleSubject}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Subject
                        </option>
                        {subjectList.map((item) => (
                          <option key={item.SubjectID} value={item.SubjectID}>
                            {item.SubjectName}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Term</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectTerm}
                        onChange={handleTerm}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Term
                        </option>
                        {termList.map((item) => (
                          <option key={item.TermID} value={item.TermID}>
                            {item.Term}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Date</label>
                      <Calendar
                        className="form-control form-control-sm searchField"
                        dateFormat="YYYY/MM/DD"
                        theme="default"
                        language="en"
                        values={selectDate}
                        onChange={handleDate}
                      />
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Theme</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectTheme}
                        onChange={handleTheme}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Theme
                        </option>
                        {themeList.map((item) => (
                          <option key={item.ThemeID} value={item.ThemeID}>
                            {item.Theme}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>

                    <div className="col-md-2 col-sm-2 col-lg-2 dropdown2">
                      <label className="list-label">Achievement</label>
                      <select
                        style={{ fontSize: "11px" }}
                        value={selectAchieve}
                        onChange={handleAchieve}
                        className="form-control form-control-sm"
                      >
                        <option value="" disabled style={{ fontSize: "11px" }}>
                          Select Achievement
                        </option>
                        {achieveList.map((item) => (
                          <option
                            key={item.AchieveID}
                            value={item.AchieveID}
                          >
                            {item.Achieve}
                          </option>
                        ))}
                      </select>
                      <i className="fas fa-angle-down notificationpositon"></i>
                    </div>
                  </>
                }
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
